
import '@/assets/scss/index.scss'
import _ from 'lodash'
import dayjs from 'dayjs'
import { formatter } from '~/mixin/fomatter.js'
import TitleCmp from '@/components/ds/common/TitleCmp.vue'
import ProdSwiperCmp from '@/components/ds/common/ProdSwiperCmp.vue' // 스와이프
import DSLIST from '~/components/ds/dsa/dsList.vue'
import spbkMixin from '@/mixin/or/spbkMixin'
import { commonfunc } from '~/mixin/common'

export default {
  components: {
    TitleCmp,
    ProdSwiperCmp,
    //  ProdUnitCmp,
    DSLIST
    // ProdFilter
  },
  mixins: [spbkMixin, formatter, commonfunc],
  // layout: 'pubLayout',
  layout: 'DsMainLayout',
  props: {
    cart: { // 장바구니 버튼 노출/비노출 여부
      type: Boolean,
      default: true
    },
    radio: { // 라디오 선택
      type: Boolean,
      default: false
    },
    ranking: { // 링킹 유닛
      type: Boolean,
      default: false
    },
    long: { // long type veideo
      type: Boolean,
      default: false
    }
  },
  asyncData ({ $api, params }) {
    const exhCnrId = params.id
    const brndId = params.brandId
    return {
      exhCnrId,
      brndId // test brand 아이디 00006
    }
  },
  data () {
    return {
      tabReady: false,
      swiperOpt: { // swiper options
        slidesPerView: 1,
        loop: false,
        spaceBetween: 28,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets', // 버튼 디자인 bullets" / "fraction"
          renderBullet (index, className) {
            return '<button type="button" aria-label="' + (index + 1) + '번 슬라이드로 이동하기" class="' + className + '"><span class="blind">' + (index + 1) + '</span></button>'
          },
          renderFraction (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '<span>/</span>' + '<span class="' + totalClass + '"></span>'
          }
        },
        threshold: 30,
        watchOverflow: true, // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
        slidesPerColumn: 1,
        slidesPerGroup: 1
        // grid: {
        //   rows: 2
        // }
        // slidesPerColumnFill: 'column'
      },
      titleData: {
        title: '브랜드 모아보기',
        crumbs: [
          // {
          //   id: '1',
          //   tit: '홈',
          //   link: '/'
          // },
          // {
          //   id: '2',
          //   tit: '메뉴',
          //   link: ''
          // },
          // {
          //   id: '3',
          //   tit: '브랜드 모아보기',
          //   link: ''
          // }
        ]
      },
      active: '1',
      tabsDataRdo: [ // 탭 data
        {
          id: '1',
          title: '1 ~ 10위',
          label: '1'
        },
        {
          id: '2',
          title: '11 ~ 20위',
          label: '2'
        }
      ],
      select1: '추천순',
      options1: [{
        value: '',
        label: '추천순'
      }, {
        value: 'new',
        label: '신상품순'
      }, {
        value: 'order',
        label: '판매량순'
      }, {
        value: 'revw',
        label: '리뷰많은순'
      }, {
        value: 'like',
        label: '좋아요순'
      }, {
        value: 'highPrc',
        label: '가격높은순'
      },
      {
        value: 'lowPrc',
        label: '가격낮은순'
      }],

      tabProdSwiperOpt: {
        pagination: 'tab',
        lockClass: 'lock2'
      },

      planProdSwiperOpt: {
        pagination: false,
        slidesPerView: 3
      },
      tabIndicator: ['1~10위', '11~20위'],
      bestList: [],
      brandProd: [],
      brandList: [],
      bestRankList: [],
      brandNm: '',
      bestSearchData: { // 고객반응베스트 req파라미터
        searchTerm: '',
        searchQuery: 'R2',
        brndCd: '',
        pageNum: 1,
        cntPerPage: 20
      },
      flagList: [],
      topFlagList: [],
      prd: {
        spbkSeCd: '', // [필수] 장바구니유형코드 [01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량구매],
        chnlCd: '', // [필수] 채널코드,
        orMdiaCd: '', // [필수] 주문매체코드
        pdNo: '', // 상품번호,
        onldPdNo: '', // 온라인전용상품번호,
        bunPdNo: '', // 묶음상품번호,
        spbkQy: '', // [필수] 장바구니수량,
        lsUpdrId: '' // [필수] 화면ID(최종수정자아이디)
      },
      evReq: {
        currentPage: 1,
        pageSize: 20,
        firstIndex: 0,
        lastIndex: 0,
        aplMdiaPcomYn: 'Y',
        aplMdiaMblWebYn: '',
        aplMdiaMblAppYn: '',
        exclEvtStsCd: '',
        evtStsCd: '20', // 이벤트상태코드 (10:대기, 20:진행, 30:종료)
        evtSeCd: '03', // 이벤트구분코드 (01:다이소몰, 02:제휴, 03:브랜드)
        exhYn: 'Y',
        delYn: '',
        wnrPstgYn: '',
        sortMth: 'evt_ed_dtm', // 이벤트 마감일 임박순으로 조회
        prtpYn: false,
        mbMngNo: ''
      },
      evList: [],
      reqData: { // 검색솔루션 리퀘스트파라미터
        searchTerm: '',
        searchQuery: 'R13', // 브랜드 상품
        brndCd: '',
        pageNum: 1,
        cntPerPage: 19,
        exhCtgrNo: '',
        searchSort: '',
        dvrTy: '',
        goodsType: '',
        revwStsc: '',
        pdPrcRange: ''
      },
      resdataList: [], // 상품 더보기 검색솔루션 res
      displayList: [],
      bannerList: [],
      isLoading: false,
      badge: {},
      adltCtfcYn: this.$store.getters['session/getAdltCtfcYn'],
      adltCtfcCd: this.$store.getters['session/getAdltCtfcCd'],
      mb: this.$store.getters['session/getMb'],
      listYn: true, // 단순 구분용 ....
      textCmptmtList: [],
      exhbProdCmptmtList: [],
      textList: [],
      exhbProdList: [],
      exhTestList: [],
      dataSet: {
        id: '',
        exbtNo: '',
        name: '',
        desc: '',
        thumb: '',
        banrTypCd: '',
        eyebrow: {
          text: '',
          color: ''
        },
        reviewNum: '',
        video: '',
        pcVideoAtchFileUrl: '',
        topFlag: '',
        goodsItem: [] // productDataSet
      },
      planSwiperOpt: { // 기획전 상품 리스트형 swiper options
        slidesPerView: 1,
        loop: false,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      exhbFinalList: [],
      exhbList: [],
      testData: {},
      groupResult: [],
      prodTotal: 0,
      totalSize: ''
    }
  },
  computed: {
    setVideo (item) {
      if (item.banrTypCd === '20') {
        const video = { // video 기본 옵션 설정
          controls: false, // 컨트롤 바 노출 여부
          autoplay: false, // 자동재생
          muted: true, // 음소거
          loop: true,
          preload: 'auto', // 즉시 비디오 데이터를 다운로드 시작할지 여부 결정
          poster: '', // 썸네일 이미지
          sources: [
            {
              src: '/images/tempLy/sample_detail.mp4',
              type: 'video/mp4'
            }
          ],
          playbackRates: [1] // 배속
        }
        video.sources[0].src = this.imgUrlMaker(item.pcVideoAtchFileUrl)
        // console.table('video :::: ', video)
        return video
      } else {
        return {}
      }
    }
  },
  watch: {
  },
  created () {
    // 인디케이터

  },
  async  mounted () {
    await this.selectBrndInfo()
    await this.searchBest()
    this.createTab()
    // await this.getEventList()
    //  await this.searchTotal()
    // await this.selectItemBnn()
    await this.selectExhbList()
  },
  methods: {
    errorImage (e) {
      e.target.src = '/images/tempLy/goods_img_5.png'
    },
    async selectBrndInfo () {
      const brndParam = {
        brndCd: this.brndId
      }
      //  this.brandList = this.bndid
      // brndParam.brndCd = '00004'
      this.brandList.push(brndParam)

      // debugger
      await this.$AxiosBuilder
        .data(this.brandList)
        .build()
        .post('/pdo/pdBrndList')
        .then((res) => {
          const list = res.data.data
          console.log('list', list)

          list.forEach((item, i) => {
            const newItem = Object.assign({}, {
              id: item.brndCd,
              video: '',
              thumb: this.imgUrlMaker(item.imgPcomAtchFileUrl),
              eyebrow: {
                text: item.engBrndNm,
                color: '#646F7C' // 고정 컬러
              },
              title: item.brndNm,
              desc: _.unescape(item.brndDc.replace(/\n/g, '<br>')),
              total: this.setTotal(item.pdCnt)
            })
            this.brandNm = item.brndNm
            this.brandProd.push(newItem)
          })
        }).catch((err) => {
          console.log(err)
        //  debugger
        })
    },
    async searchBest () {
      this.bestSearchData.brndCd = this.brndId
      await this.$AxiosBuilder
        .params(this.bestSearchData, false)
        .baseURL(process.env.API_SSN_BASE_URL2)
        .build()
        .get('/GoodsBrand')
        .then((res) => {
          const testList = res.data.resultSet.result[res.data.resultSet.result.length - 1].resultDocuments

          _.flatMap(testList, (item, index) => {
            const result = { ...item, banner: 'N' }
            this.bestList.push(result)
          })

          // 리스트쪼개기
          this.bestRankList = []
          const tempArr1 = []
          const tempArr2 = []
          this.bestList.forEach((item, index) => {
            if (index < 10) {
              tempArr1.push(item)
            } else {
              tempArr2.push(item)
            }
          })

          this.tabIndicator = []
          if (tempArr1.length > 0) {
            this.bestRankList.push(tempArr1)
            this.tabIndicator.push('1~10위')
          }
          if (tempArr2.length > 0) {
            this.bestRankList.push(tempArr2)
            this.tabIndicator.push('11~20위')
          }

          // if (this.bestList.length > 10) {
          // this.bestRankList.push(this.bestList.slice(10, 20))
          //   this.tabIndicator = ['1~10위', '11~20위']
          // }
          //
          console.log('고객반응테스트', this.bestList.length)
          // console.log('탭 테스트 ', this.tabIndicator)
        }).catch((err) => {
          console.log(err)
        //  debugger
        })
    },
    getBrandItemTotal (total) {
      this.totalSize = total
    },
    getEventList () {
      this.$AxiosBuilder
        .data(this.evReq)
        .build()
        .post('/ev/evc/selEvtList')
        .then((res) => {
          const list = res.data.data.evtList
          list.forEach((item, i) => {
            const newItem = Object.assign({}, {
              id: item.evtCd,
              thumb: '/images/tempLy/event_img_01.png', // item.pcomIconAtchFileId
              name: item.evtNm,
              date: item.evtStDtm + '~' + item.evtEdDtm, // '2023.01.01 ~ 2023.01.05',
              ing: true,
              winner: item.wnrAnumDtm,
              winnerLink: '',
              url: item.pcomDtlPageUrl,
              flag: ['브랜드'],
              time: { // 추후 수정 해야함
                day: this.getDiffDate(item.evtCmprDtm, item.nowCmprDtm, item.cmprTime)
              }
            })
            if (i < 19) { // 이벤트는 최대 18개까지만
              this.evList.push(newItem)
            }
          })
        }).catch((err) => {
          console.log(err)

        //  debugger
        })
    },
    async selectExhbList () {
      const reqdata = {
        brndCd: this.brndId,
        exbtListExprYn: 'Y'
      }
      const resData = await this.$AxiosBuilder
        .data(reqdata)
        .build()
        .post('/ds/exbt/selExbt')
        .then((res) => {
          //  exhMtrlTyCd  01:배너  02:상품  03: 텍스트  (textTyCd 10:아이브로우 20:메인 30:서브)
          return res.data.data
        }).catch((err) => {
          console.log(err)
        })
      //  console.table('기획전 목록 :: ', resData)
      const result = {}

      if (resData !== null && resData !== undefined) {
        this.testData = resData

        for (let i = 0; i < resData.length; i++) {
          const mtrls = resData[i].mtrls
          const list = []
          const exhbInfo = {
            exbtThmeNm: resData[i].exbtThmeNm,
            exbtThmeBgColorCd: resData[i].exbtThmeBgColorCd,
            reviewNum: resData[i].inct,
            exbtNo: resData[i].exbtNo
          }
          for (let j = 0; j < mtrls.length; j++) {
            const resObj = await this.selectMtrls(mtrls[j], result, exhbInfo) /// 기획전 안 소재 정보 조회

            if (Object.keys(resObj).length > 0) {
              list.push(resObj)
            }
            //    console.table('기획전안 소재 리스트::: ', list)
          }

          this.exhbList.push(list)
        }

        //  console.table('기획전 목록 최종 ::: ', this.exhbList)
        // 테스트  s

        this.exhbList.forEach((item, idx) => {
          const newDataSet = { ...this.dataSet }
          newDataSet.id = idx

          newDataSet.goodsItem = []
          //  console.table('기획전 1개 i', idx, ' item.....', item)
          item.forEach((mItem, index) => {
            // console.table('index:::', index, ' exhbInfo.....', mItem.exhbInfo)
            const newFlag = [{
              text: mItem.exhbInfo.exbtThmeNm,
              bgColor: mItem.exhbInfo.exbtThmeBgColorCd,
              // reviewNum: mItem.exhbInfo.reviewNum === null ? 0 : mItem.exhbInfo.reviewNum
            }]
            newDataSet.exbtNo = mItem.exhbInfo.exbtNo
            newDataSet.topFlag = newFlag
            newDataSet.reviewNum = mItem.exhbInfo.reviewNum === null ? 0 : mItem.exhbInfo.reviewNum

            console.table('기획전 소재1개 ', index, ' mItem.....', mItem)
            if (mItem.matDtl !== null && mItem.matDtl !== undefined) {
              if (mItem.typeCd === '01' && mItem.matDtl[0] !== undefined) { // 배너형
                newDataSet.thumb = mItem.matDtl[0].banrTypCd !== '20' ? mItem.matDtl[0].pcomIconAtchFileUrl : mItem.matDtl[0].pcThmnlAtchFileUrl
                newDataSet.banrTypCd = mItem.matDtl[0].banrTypCd
                if (mItem.matDtl[0].banrTypCd === '20') {
                  newDataSet.pcVideoAtchFileUrl = mItem.matDtl[0].pcVideoAtchFileUrl
                  newDataSet.video = mItem.matDtl[0].pcVideoAtchFileUrl
                }
              } else if (mItem.typeCd === '02') { // 상품형
                //     console.table('기획 상품::: ', mItem)
                mItem.matDtl.forEach((pdItem, pdIdx) => {
                  const newPrdDataSet = {
                    id: newDataSet.id + '_' + (pdIdx + 1),
                    pdNo: pdItem.pdNo,
                    thumb: this.imgUrlMaker(pdItem.mrImgUrl),
                    // thumb: item.mrImgUrl - 정보 필요 (9/6)
                    name: pdItem.pdNm,
                    price: this.setPrice(pdItem.pdPrc),
                    reviewNum: pdItem.revwCnt, // 상품평 개수
                    // best: true, // 최다 리뷰 상품 여부 - 정보 필요 (9/6)
                    reviewScore: pdItem.avgStscVal, // 상품평점 - 정보 필요 (9/6)
                    onlyOnlYn: pdItem.onlyOnlYn,
                    bunYn: pdItem.bunYn,
                    pkupDdcatYn: pdItem.pkupDdcatYn,
                    best: true, // BEST 문구 (상품 타이틀 앞) - 아직 데이터 없음, 정보 필요 (9/6)
                    total: pdItem.totOrQy, // 판매 개수
                    flag1: pdItem.newPdYn === 'Y', // 신상 (하단 flag)
                    flag2: pdItem.onlyOnlYn === 'Y', // 온라인 전용 (하단 flag)
                    flag3: true, // goods (하단 flag) - 의미?
                    optPdYn: pdItem.optPdYn
                  }
                  newDataSet.goodsItem.push(newPrdDataSet)
                })
              } else if (mItem.typeCd === '03') { // 텍스트형
                mItem.matDtl.forEach((txItem) => {
                  const eyeObj = {
                    text: txItem.textNm,
                    color: txItem.textFontColorCd
                  }
                  switch (txItem.textTyCd) {
                    case '10': // 아이브로우
                      newDataSet.eyebrow = eyeObj
                      break
                    case '20': // 메인 텍스트
                      newDataSet.name = eyeObj.text
                      break
                    case '30': // 서브텍스트
                      newDataSet.desc = eyeObj.text
                      break
                  }
                })
              }
            }
          //   })
          })
          this.exhbFinalList.push(newDataSet)
        })

        console.table('this,exhbFinalList ::::: ', this.exhbFinalList)
      }
    },

    async selectMtrls (obj, result, exhbInfo) { // 기획전에 묶인 소재 조회하기!
      if (obj.exhMtrlTyCd === '01') { // 배너 소재
        result = {
          exhbInfo,
          typeCd: obj.exhMtrlTyCd,

          matDtl: await this.selBnn(obj)
        }
      } else if (obj.exhMtrlTyCd === '02') { // 상품소재
        result = { exhbInfo, typeCd: obj.exhMtrlTyCd, matDtl: await this.selProduct(obj) }
      } else if (obj.exhMtrlTyCd === '03') { // 텍스트 소재
        result = { exhbInfo, typeCd: obj.exhMtrlTyCd, matDtl: await this.selText(obj) }
      } else {
        console.log('기획전 소재없음!!!')
      }
      //   console.table(' result ::: ', result, '   obj::', obj)
      return result
    },
    async selBnn (obj) {
      const param = {
        exhCmptmtId: obj.exhCmptmtId,
        exhMtrlNo: obj.exhMtrlNo
      }

      const result = await this.$AxiosBuilder
        .data(param)
        .build()
        .post('/ds/exh/selBanr')
        .then((res) => {
          //  exhMtrlTyCd  01:배너  02:상품  03: 텍스트  (textTyCd 10:아이브로우 20:메인 30:서브)
          if (res.data.data !== undefined && res.data.data !== '' && res.data.data !== null) {
            const testList = res.data.data.details
            return testList
          }
        })
      return result
    },
    async selProduct (obj) {
      const param = {
        exhCmptmtId: obj.exhCmptmtId,
        exhMtrlNo: obj.exhMtrlNo
      }
      /*
      {
  "lastNumber": 0,
  "pageSize": 6,
  "exhCmptmtId": "2023071101",
  "exhMtrlNo": "1",
  "soldOutExprYn": "Y"
}
      */
      const result = await this.$AxiosBuilder
        .data(param)
        .build()
        .post('/ds/exh/selProduct')
        .then((res) => {
          //  exhMtrlTyCd  01:배너  02:상품  03: 텍스트  (textTyCd 10:아이브로우 20:메인 30:서브)
          const testList = res.data.data.details
          return testList
        })
      return result
    },
    async selText (obj) {
      const param = {
        exhCmptmtId: obj.exhCmptmtId,
        exhMtrlNo: obj.exhMtrlNo
      }

      const result = await this.$AxiosBuilder
        .data(param)
        .build()
        .post('/ds/exh/selText')
        .then((res) => {
          //  exhMtrlTyCd  01:배너  02:상품  03: 텍스트  (textTyCd 10:아이브로우 20:메인 30:서브)
          const testList = res.data.data
          return testList
        })
      return result
    },
    setPrice (str) {
      return Number(str.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
    },
    setTotal (cnt) {
      console.log('cnt ', cnt)
      if (typeof cnt === 'number') {
        if (cnt > 9999 && cnt <= 99999) {
          return '9.9+ 천'
        } else if (cnt > 99999) {
          return '99.9+ 만'
        } else {
          return Number(cnt).toLocaleString('ko-KR')
        }
      } else if (typeof cnt === 'string') {
        if (Number(cnt.replace(/[^0-9]/g, '')) > 9999 && Number(cnt.replace(/[^0-9]/g, '')) <= 99999) {
          return '9.9+ 천'
        } else if (Number(cnt.replace(/[^0-9]/g, '')) > 99999) {
          return '99.9+ 만'
        }
        return Number(cnt.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      } else {
        return Number(cnt.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    getDiffDate (evtCmprDtm, nowCmprDtm, cmprTime, str) { // getDiffDate(item.evtCmprDtm, item.nowCmprDtm)
      evtCmprDtm = dayjs(dayjs(evtCmprDtm).format('YYYY-MM-DD HH:mm')) // 이벤트비교일시
      nowCmprDtm = dayjs(dayjs(nowCmprDtm).format('YYYY-MM-DD HH:mm')) // 현재비교일시
      const cmprDtm = evtCmprDtm.diff(nowCmprDtm, 'd') // 비교일시

      if (cmprDtm > 0) {
        str = cmprDtm + ' 일 ' + cmprTime
      } else if (cmprDtm === 0) {
        str = cmprTime
      } else {
        str = ''
      }

      return str
    },
    goPdDetail (obj) {
      this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.id } })
    },
    cartClick (obj) {
      this.clickAddSpbkBtn(obj)
    },
    async adultCert (obj) {
      if (this.mb.mbMngNo === undefined) { // 로그인 정보가 없으면 로그인페이지로 이동
      //  if (await this.confirm(this.$t('PD.LOGIN_ADULT'))) {

        const returnUrlPath = '/pd/pdr/SCR_PDR_0001?pdNo=' + obj.pdNo
        const nowPath = this.$route.fullPath
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: returnUrlPath, adltAuth: 'Y', adltReturnUrl: nowPath } })
        //  }
        return
      }

      if (this.mb.mbMngNo !== undefined && this.adltCtfcCd === '02') { // 로그인되어 있고 성인인증 미인증
      // 로그인 되어있고 성인인증안했으면
      //  const url = this.$route.path
        if (await this.confirm(this.$t('PD.CERTIFY_ADULT'), { center: true, dangerouslyUseHTMLString: true })) {
          this.$router.push({
            name: 'mb-mbc-SCR_MBC_0110A_01',
            path: '/mb/mbc/SCR_MBC_0110A_01',
            params: { redirectUrl: '/pd/pdr/SCR_PDR_0001?pdNo=' + obj.pdNo } // redirectUrl: 인증완료 후 리턴할 상품화면
          })
        }
      } else if (this.mb.mbMngNo !== undefined && this.adltCtfcCd === '03') { // 로그인 되어 있고 성인인증 인증만료
      // 로그인 되어있고 성인인증안했으면
      //  const url = this.$route.path
        if (await this.confirm(this.$t('PD.DTL_CERTIFY_ADULT_EXPIRED'), { center: true, dangerouslyUseHTMLString: true })) {
          this.$router.push({
            name: 'mb-mbc-SCR_MBC_0110A_01',
            path: '/mb/mbc/SCR_MBC_0110A_01',
            params: { redirectUrl: '/pd/pdr/SCR_PDR_0001?pdNo=' + obj.pdNo } // redirectUrl: 인증완료 후 리턴할 상품화면
          })
        }
      } else {
      // 로그인되어 있고 성인인증도 되어있으면 상품상세로 이동....
        this.sendFeedback(obj)
        this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo } })
      }
    },
    async detailAdultCert (obj) { // 상품설명 클릭시 성인인증 필요한 상품 , 판매예정?상품 처리
      if (obj.buyLmtAgeCd === '03' && this.adltCtfcYn !== 'Y') {
        this.adultCert(obj)
      } else if (obj.wrhParmDt !== '' && obj.sleStsCd === '02') { // 판매예정인경우
        if (await this.confirm(this.$t('PD.NOTIFY_PD_CONFIRM'))) {
          this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo } })
        }
      } else {
        this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo } })
      }
    },
    createTab () {
      if (this.tabProdSwiperOpt.pagination === 'fraction') {
        this.swiperOpt.pagination.type = this.tabProdSwiperOpt.pagination
      } else if (this.tabProdSwiperOpt.pagination === 'tab') {
        console.log('created', this.bestRankList.length)
        const tabInd = this.tabIndicator
        console.log('tabInd ', tabInd)

        this.swiperOpt.pagination = {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets', // 버튼 디자인 bullets" / "fraction"
          renderBullet (index, className) {
            console.log('index  ', index, 'className ', className)
            return '<button type="button" aria-label="' + (index + 1) + '번 슬라이드로 이동하기" class="' + className + '"><span class="">' + tabInd[index] + '</span></button>'
          }
        }
        console.log('this.swiperOpt ::', this.swiperOpt)
      }
      this.tabReady = true
    },
    play (id) { // 재생 이벤트 전달 23.10.13
    //  console.log('ref', ref)
    //  this.$emit('play-event', ref, id)
      this.$refs['video' + id].player.play()
    },
    stop (id) { // 정지 이벤트 전달 23.10.13
    // console.log('ref', ref)
    // this.$emit('stop-event', ref, id)
      this.$refs['video' + id].player.pause()
    },
  }

}
